import type {
  ErrorMessage,
  BaseMessage,
  SearchEndMessage,
  CompleteMessage,
  AgentMessage,
  SearchSummaryEndMessage,
  QueryRewriteEndMessage,
  SearchStartMessage,
  QueryRewriteStartMessage,
  SearchSummaryStartMessage,
} from '~/types/agent';

const isMessage = (message: unknown): message is BaseMessage => {
  return typeof message === 'object' && message !== null && 'type' in message;
};

export const isQueryRewriteStartMessage = (message: unknown): message is QueryRewriteStartMessage => {
  return isMessage(message) && message.type === 'node_start' && (message as QueryRewriteStartMessage).node === 'hn_query_rewriter';
};

export const isQueryRewriteEndMessage = (message: unknown): message is QueryRewriteEndMessage => {
  return isMessage(message) && message.type === 'node_end' && (message as QueryRewriteEndMessage).node === 'hn_query_rewriter';
};

export const isSearchStartMessage = (message: unknown): message is SearchStartMessage => {
  return isMessage(message) && message.type === 'node_start' && (message as SearchStartMessage).node === 'hn_search';
};

export const isSearchEndMessage = (message: unknown): message is SearchEndMessage => {
  return isMessage(message) && message.type === 'node_end' && (message as SearchEndMessage).node === 'hn_search';
};

export const isSearchSummaryStartMessage = (message: unknown): message is SearchSummaryStartMessage => {
  return isMessage(message) && message.type === 'node_start' && (message as SearchSummaryStartMessage).node === 'hn_search_summary';
};

export const isSearchSummaryEndMessage = (message: unknown): message is SearchSummaryEndMessage => {
  return isMessage(message) && message.type === 'node_end' && (message as SearchSummaryEndMessage).node === 'hn_search_summary';
};

export const isCompleteMessage = (message: unknown): message is CompleteMessage => {
  return isMessage(message) && message.type === 'complete';
};

export const isErrorMessage = (message: unknown): message is ErrorMessage => {
  return isMessage(message) && message.type === 'error';
};

export const isFinalMessage = (message: AgentMessage): boolean =>
  isCompleteMessage(message) || (isErrorMessage(message) && message.data.code !== 408);
